module.exports = __webpack_public_path__ + "static/media/bg-image-49.2008defb.jpg";